<template>
  <div>
    <v-stepper :value="page_step_panel_state" alt-labels class="" elevation="0">
      <v-stepper-header>
        <v-stepper-step
          :step="1"
          :complete="
            panel_state > PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS
          "
          :color="
            panel_state > PANEL_ALL_PAGE_STATE.CONFIRM_CONSENT_BEFORE_REGIS
              ? 'green'
              : 'deep-orange'
          "
        >
          {{ $t("pre_regis_stepper.start") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :step="2"
          :complete="panel_state > PANEL_ALL_PAGE_STATE.ADD_SUBJECT"
          :color="
            panel_state > PANEL_ALL_PAGE_STATE.ADD_SUBJECT
              ? 'green'
              : 'deep-orange'
          "
        >
          {{ $t("pre_regis_stepper.select_subject") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :step="3"
          :complete="panel_state >= PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT"
          :color="
            panel_state >= PANEL_ALL_PAGE_STATE.COMPLETE_SUBJECT
              ? 'green'
              : 'deep-orange'
          "
        >
          {{ $t("pre_regis_stepper.complete") }}
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <div class="ml-3 mb-5">
      <v-btn
        color="blue-grey"
        class="white--text mr-3 mb-2"
        @click="OpenCurriculumPageOAQ()"
      >
        {{ $t("pre_regis_stepper.curriculumOAQ") }}
        <v-icon right dark>
          mdi-book
        </v-icon>
      </v-btn>
      <v-btn
        color="blue-grey"
        class="white--text mr-3 mb-2"
        @click="OpenCurriculumPage()"
      >
        {{ $t("pre_regis_stepper.curriculum") }}
        <v-icon right dark>
          mdi-book
        </v-icon>
      </v-btn>
      <v-btn
        color="blue-grey"
        class="white--text mr-3 mb-2"
        @click="OpenTimetablePage()"
      >
        {{ $t("pre_regis_stepper.timetable") }}
        <v-icon right dark>
          mdi-table-clock
        </v-icon>
      </v-btn>
      <v-btn
        color="blue-grey"
        class="white--text mr-3 mb-2"
        @click="OpenEducalendarPage()"
      >
        {{ $t("pre_regis_stepper.academic_calendar") }}
        <v-icon right dark>
          mdi-calendar-month
        </v-icon>
      </v-btn>
      <v-btn
        color="amber accent-3"
        class="black--text mr-3 mb-2"
        :to="{ path: 'payment' }"
      >
        <v-icon>mdi-currency-thb</v-icon>
        {{ $t("payment.title") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreRegisStepper",
  props: {
    page_step_panel_state: {},
    panel_state: {},
    PANEL_ALL_PAGE_STATE: {},
    level_id: {
      type: Number,
      default: 1,
    },
    sub_level_id: {
      type: Number,
      default: null,
    },
  },
  methods: {
    OpenCurriculumPage() {
      window.open("https://www.reg.kmitl.ac.th/curriculum/", "_blank");
    },
    OpenCurriculumPageOAQ() {
      window.open("https://office.kmitl.ac.th/oaq/curriculum/", "_blank");
    },
    OpenTimetablePage() {
      if (
        this.level_id !== 1 ||
        (this.level_id === 1 && this.sub_level_id === 1)
      ) {
        window.open("https://www.reg.kmitl.ac.th/teachtable_v20_x/", "_blank");
      } else {
        window.open("#/teach_table_selector", "_blank");
      }
    },
    OpenEducalendarPage() {
      window.open("https://www.reg.kmitl.ac.th/educalendar/", "_blank");
    },
  },
};
</script>

<style></style>
